// Firebase initialization for the Camplocation admin panel.
//
// Fill these in with your project's web config (Firebase console →
// Project settings → General → "Your apps" → SDK setup and configuration).
// You can either hardcode the values below or provide them through
// REACT_APP_* environment variables (a .env file in the project root).
//
// `databaseURL` must be the same Realtime Database URL the Android app uses
// (the value of R.string.firebaseURL).
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? 'YOUR_API_KEY',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? 'YOUR_PROJECT.firebaseapp.com',
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL ?? 'https://YOUR_PROJECT-default-rtdb.firebaseio.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? 'YOUR_PROJECT',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? 'YOUR_PROJECT.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? 'YOUR_SENDER_ID',
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? 'YOUR_APP_ID',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app);
export default app;
